/*----------------------------------------------------------------------------*\
    EMBEDDING.child
    child part of the iframe embedding
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};
oy.embedding = oy.embedding || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */



/*  Component
\*----------------------------------------------------------------------------*/

oy.embedding.child = {
    // Gonna fill this later with the origin of the parent
    parentOrigin: '',
    isInitialised: false,
    parentScrollTop: 0,
    parentFramePosition: 0,
    frameHeight: 0,
    parentViewportHeight: 0,
    hostName: '',


    init: function(){
        var self = this;

        if (oy.embedding.isEnabled) {
            self.isInitialised = true;
            self.postHeight();

            window.addEventListener(oy.settings.embedHeightChangeName, function () {
                self.postHeight();
            }, false);

            fetch('//'+window.location.hostname+'/umbraco/Api/ThirdPartyCookieApi/SetCookieForThirdPartyCheck')
            .then(function(){  self.postCookieStatus();
            }
            );

        }
    },

    /**
     * Posts height to parent frame
     */
    postHeight: function() {
        var self = this;
        if (oy.embedding.isEnabled) {
            var height = self._getHeight();
            self.frameHeight = height;
            window.requestAnimationFrame(function(){
                window.parent.postMessage({
                    'height': height
                }, self.parentOrigin);
            });
        }
    },
    postCookieStatus: function() {
        var self = this;
        if (oy.embedding.isEnabled) {
            window.requestAnimationFrame(function(){

                fetch('//'+window.location.hostname+'/umbraco/Api/ThirdPartyCookieApi/GetCookieForThirdPartyCheck')
                .then(response => response.json())
                .then(function(response){
                    window.parent.postMessage({
                        'thirdpartyCookieSet': response
                    }, self.parentOrigin);
                });
            });
        }
    },

    /**
     * Get the height of the all child elements of main
     */
    _getHeight: function () {
        var contentIframe = document.querySelectorAll('main > *');

        var height = 0;

        for(var i=0;i<contentIframe.length;i++) {
            height += contentIframe[i].offsetHeight;
        }

        return height;
    }
};


/*  Events
\*----------------------------------------------------------------------------*/

window.addEventListener('optimizedResize', function() {
    oy.embedding.child.postHeight();
});


/**
 * Listen to received post messages from parent
 */
window.addEventListener('message', function(e) {
    if (oy.embedding.isEnabled) {
        var message = e.data;
        //console.log('Child: message received from parent: ', message);
        // Check if parentOrigin is present in data && if data is not stored already
        if (message.parentOrigin && oy.embedding.child.parentOrigin !== message.parentOrigin) {
            oy.embedding.child.parentOrigin = message.parentOrigin;

            // Fire all the things
            oy.embedding.child.init();
        }
        if (message.framePosition !== undefined && message.scrollTop >= 0 && message.viewportHeight !== undefined) {
            oy.embedding.child.parentScrollTop = message.scrollTop;
            oy.embedding.child.parentFramePosition = message.framePosition;
            oy.embedding.child.parentViewportHeight = message.viewportHeight;
            oy.embedding.child.parentDocumentHeight = message.documentHeight;
            window.requestAnimationFrame(function(){
                window.dispatchEvent(oy.settings.embedScrollChange);
            });
        }

    }
});
